module.exports = __webpack_public_path__ + "img/background.362f0f0a.jpg";